import React, { useEffect } from 'react';
import { MealBuilder } from '../components/MealBuilder';
import { useRecipeStore } from '../store/recipeStore';

export function MealsPage() {
  const { fetchRecipes, fetchMeals } = useRecipeStore();

  useEffect(() => {
    // Fetch both recipes and meals when the meals page loads
    Promise.all([fetchRecipes(), fetchMeals()]);
  }, [fetchRecipes, fetchMeals]);

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <MealBuilder />
    </div>
  );
}